import { useMemo, useState } from "react";
import { isValidDate, renderCalendar } from "../../../../utils/date";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import MyButton from "../../../MyButton";
import MySelect from "../../MySelect";

const MyCalendar = (props) => {
  const { value = null, onChange = () => {}, onClose = () => {} } = props;

  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState({
    date: isValidDate(value) ? dayjs(value).date() : null,
    month: isValidDate(value) ? dayjs(value).month() : new Date().getMonth(),
    year: isValidDate(value) ? dayjs(value).year() : new Date().getFullYear(),
  });

  const renderCalendarTable = useMemo(
    () => renderCalendar(selectedDate.year, selectedDate.month) || [],
    [selectedDate]
  );

  const numberOfRow = useMemo(
    () => renderCalendarTable?.length / 7,
    [renderCalendarTable]
  );

  const months = Array.from({ length: 12 }, (_, index) => ({
    value: index,
    label: t("common.calendar.month", { month: index + 1 }),
  }));
  const years = Array.from({ length: 100 }, (_, index) => ({
    value: index + 1940,
    label: index + 1940,
  })).reverse();

  const setDate = (date) => {
    const newSelectedDate = { ...selectedDate };
    newSelectedDate.date = date;
    setSelectedDate(newSelectedDate);
  };

  const handleYearChange = (year) => {
    const newSelectedDate = { ...selectedDate };
    newSelectedDate.year = year;
    setSelectedDate(newSelectedDate);
  };

  const handleMonthChange = (month) => {
    const newSelectedDate = { ...selectedDate };
    newSelectedDate.month = month;
    setSelectedDate(newSelectedDate);
  };

  const completeSelectDate = () => {
    if (!selectedDate.date) {
      onChange(null);
    } else {
      onChange(
        new Date(selectedDate.year, selectedDate.month, selectedDate.date)
      );
    }
    onClose();
  };

  const onClearValue = () => {
    setSelectedDate({
      date: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    });
  };

  return (
    <div>
      <div className="flex items-center justify-between gap-4 mb-2">
        <div className="flex-1">
          <MySelect
            value={selectedDate.year}
            onChange={handleYearChange}
            options={years}
          />
        </div>

        <div className="flex-1">
          <MySelect
            value={selectedDate.month}
            onChange={handleMonthChange}
            options={months}
          />
        </div>
      </div>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.sun")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.mon")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.tue")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.wed")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.thu")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.fri")}
            </th>
            <th className="text-base p-2 font-bold">
              {t("common.calendar.day.sat")}
            </th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: numberOfRow }, (_, index) => index + 1).map(
            (row) => {
              const startIndex = (row - 1) * 7;
              const endIndex = startIndex + 7;
              const pageItems = renderCalendarTable.slice(startIndex, endIndex);

              return (
                <tr key={row}>
                  {pageItems.map((col) => (
                    <td key={col.value} className="py-1">
                      <div className="flex justify-center">
                        <div
                          className={`w-8 h-8 flex justify-center items-center rounded-full text-sm ${
                            !col.disabled && col.value !== selectedDate.date
                              ? "cursor-pointer hover:bg-[#F5F5F5] font-medium"
                              : "text-[#999999] opacity-70"
                          } ${
                            !col.disabled && col.value === selectedDate.date
                              ? "bg-primary text-white cursor-pointer"
                              : ""
                          }`}
                          style={{
                            transition: "all 0.2s ease",
                          }}
                          onClick={() =>
                            !col.disabled ? setDate(col.value) : null
                          }
                        >
                          {col.value}
                        </div>
                      </div>
                    </td>
                  ))}
                </tr>
              );
            }
          )}
        </tbody>
      </table>
      <div className="flex mt-4 justify-between items-center gap-1 pb-2 px-2">
        <MyButton
          color="#777777"
          variant="contained"
          style={{ fontSize: 14, height: 32 }}
          onClick={onClearValue}
        >
          초기화
        </MyButton>
        <MyButton
          color="primary"
          variant="contained"
          style={{ fontSize: 14, height: 32 }}
          onClick={completeSelectDate}
        >
          {t("common.buttons.save")}
        </MyButton>
      </div>
    </div>
  );
};

export default MyCalendar;
